<template>
  <header class="app-preview-header">
    <div class="app-preview-header-content">
      <slot />
    </div>
  </header>
</template>

<script>
  export default {
    name: 'AppPreviewHeader',
    inject: ['previewData']
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .app-preview-header {
    height: 64px;
    min-height: 64px;
    padding: 0 16px;
    display: flex;
    position: relative;
    z-index: 2;
    transition: .3s $transition-ease-out;
    transition-property: box-shadow;
    will-change: box-shadow;
    font-size: 15px;
    text-transform: uppercase;

    &.waterfall {
      box-shadow: 0 3px 1px -2px rgba(#000, .2),
                  0 2px 2px 0 rgba(#000, .14),
                  0 1px 5px 0 rgba(#000, .12);
    }
  }

  .app-preview-header-content {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
  }

</style>
